import { render, staticRenderFns } from "./afterSaleDetails.vue?vue&type=template&id=05414d29&scoped=true"
import script from "./afterSaleDetails.vue?vue&type=script&lang=js"
export * from "./afterSaleDetails.vue?vue&type=script&lang=js"
import style0 from "./afterSaleDetails.vue?vue&type=style&index=0&id=05414d29&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05414d29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05414d29')) {
      api.createRecord('05414d29', component.options)
    } else {
      api.reload('05414d29', component.options)
    }
    module.hot.accept("./afterSaleDetails.vue?vue&type=template&id=05414d29&scoped=true", function () {
      api.rerender('05414d29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/afterSale/afterSaleDetails.vue"
export default component.exports